/** RSIトークンの有効時間 [s] */
export const TOKEN_EXPIRED_SECONDS = 60 * 60;

/** RSIトークンの有効時間 [ms] */
export const TOKEN_EXPIRED_MILI_SECONDS = TOKEN_EXPIRED_SECONDS * 1000;

/** APIのデフォルトのタイムアウト */
export const DEFAULT_TIMEOUT = 40000;

/** デフォルトのContent-Type */
export const CONTENT_TYPE_JSON = { "Content-Type": "application/json; charset=utf-8" };

/** シリアルナンバーの桁数 */
export const SERIAL_NUMBER_OF_DIGITS = 10;
